<template>
  <a-dialog
    v-model="showSignerDialog"
    width="800px"
    max-width="80vw"
    persistent
    scrollable
  >
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span>{{ $t("chat.lblNewChatCreation") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>
      </v-banner>
      <v-card-text style="color: black">
          <h4 class="mb-2">{{ $t("title") }}</h4>
                  <a-text-field
                    class="locationField mb-1"
                    v-model.trim="chatForm.title"
                    :label="$t('title')"
                    dense
                    filled
                  ></a-text-field>
            <h4 class="mb-2">{{ $t("chat.lblSelectParticipant") }}</h4>
        <v-row
          no-gutters
          class="mb-2"
          v-for="(signer, index) in selectParticipantList"
          :key="signer.id"
        >
          <v-col>
            <v-card class="mx-auto" outlined>
              <!-- <v-container fill-height fluid> -->
              <v-row
                no-gutters
                align="center"
                justify="space-between"
                class="mx-3 pa-3"
              >
                <v-col cols="7">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" style="font-size: 15px">
                        {{ `${index + 1}.` }}
                        <v-avatar
                          v-if="signer.email"
                          left
                          v-bind="attrs"
                          v-on="on"
                          size="24"
                        >
                          <v-img
                            v-if="signer.profilePhoto"
                            contain
                            :src="signer.profilePhoto"
                          ></v-img>
                          <v-img
                            v-else
                            contain
                            src="@/assets/images/NoPhotoIcon.png"
                          ></v-img>
                        </v-avatar>
                        <span
                          class="ml-2"
                          v-if="signer.firstName && signer.lastName"
                          >{{ `${signer.firstName} ${signer.lastName}` }}</span
                        >
                        <span class="ml-2" v-else>{{ signer.email }}</span>
                      </span>
                    </template>
                    <span> {{ signer.email }} </span>
                  </v-tooltip>
                  <v-chip
                    class="ml-2"
                    color="neutralGray"
                    outlined
                    small
                    v-if="!signer.is_authorized"
                  >
                    {{ $t("lblAccessRevoked") }}
                  </v-chip>
                </v-col>
                <v-col cols="2">
                  <participant-action
                    @moveUp="moveUp(index)"
                    @moveDown="moveDown(index)"
                    @onDelete="confirmDelete(signer.id)"
                    :upDisabled="index === 0"
                    :downDisabled="index === chatForm.participants.length - 1"
                    :deleteDisable="signer.id == owner"
                  ></participant-action>
                </v-col>
              </v-row>
              <!-- </v-container> -->
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              class="mr-2"
              color="primary"
              small
              text
              v-bind="attrs"
              v-on="on"
              @click="openSignerSelectDialog"
            >
              <v-icon small>mdi-plus</v-icon>
              <span>{{ $t("chat.lblAddParticipant") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("chat.lblAddParticipant") }}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              class="mr-2"
              color="primaryDark"
              v-bind="attrs"
              v-on="on"
              @click="createChatBox"
              :disabled="isDirty || chatForm.participants.length <= 1"
              >{{ chatData && chatData.id ? $t("admin.update") : $t("admin.create")}} 
            </a-btn>
          </template>
          <span> {{ chatData && chatData.id ? $t("admin.update") : $t("admin.create")}}  </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              small
              color="secondary"
              @click="close()"
              v-bind="attrs"
              v-on="on"
              ><span>{{ $t("btnCancel") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnCancel") }} </span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
    <chat-participant
      v-if="showParticipantSelectDialog"
      v-model="showParticipantSelectDialog"
      :participantList.sync="chatForm.participants"
      :attendeesList="attendeesList"
      :chatData="chatData"
    ></chat-participant>
    
    <confirm-dialog ref="confirmDelete" />
  </a-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ConfirmDialog from "../../ConfirmDialog.vue";
import MessageSheet from "../../MessageSheet.vue";
import ChatParticipant from "./ChatParticipant.vue";
import ParticipantAction from "./ParticipantAction.vue";
import { createUUID } from "../../../utils/util";
import { cloneDeep } from "lodash";

export default {
  name: "ChatCreation",
  components: {
    ConfirmDialog,
    MessageSheet,
    ChatParticipant,
    ParticipantAction,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    meetingId: {
      type: String,
      required: true,
    },
    meetingTypeId: {
      type: String,
      required: true,
    },
    attendeesList: Array,
    chatData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showParticipantSelectDialog: false,
      openChatBox: false,
      chatForm: {
        id: this.chatData ? this.chatData.id : '',
        title: this.chatData ? this.chatData.title : '',
        tenantid: sessionStorage.getItem("tenantId"),
        meetingid: this.meetingId,
        meetingTypeId: this.meetingTypeId,
        participants: this.chatData ? cloneDeep(this.chatData.participants) : [],
        created_by: this.chatData ? this.chatData.created_by : this.$auth.user.user_id,
        created_date: this.chatData && this.chatData.created_date
            ? this.chatData.created_date
            : new Date().toISOString(),
        linkedMessages: this.chatData ? this.chatData.linkedMessages : [],
      }
    };
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
      deletedUserList: (state) => state.meeting.deletedUserList,
    }),
    loaderText() {
      return this.$t("LoaderText");
    },
    
    showSignerDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    participantList() {
      return this.chatForm.participants;
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    selectParticipantList() {
      let localUserList = [...this.userList];
      localUserList = localUserList.concat(this.deletedUserList);
      return this.chatForm.participants.map((obj) => {
        const userData = localUserList.find((user) => user.id === obj.id) || {};
        return {
          ...obj,
          firstName: userData.firstName || null,
          lastName: userData.lastName || null,
          profilePhoto: userData.profilePhoto || null,
          is_authorized: userData ? !userData.is_deleted : true,
        };
      });
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.selectedTenant);
      return tenant ? tenant.name : '';
    },
    isDirty() {
      if(this.chatData && this.chatData.id){
        const getEmails = participants =>  participants.map(obj => obj.email).sort();
        const participantListEmails = getEmails(this.chatData.participants);
        const oldChatData = {id: this.chatData.id, title: this.chatData.title, participants: participantListEmails}
        
        const newParticipantListEmails = getEmails(this.chatForm.participants);
        const newChatData = {id: this.chatForm.id, title: this.chatForm.title, participants: newParticipantListEmails}
        return (
          JSON.stringify(oldChatData) == JSON.stringify(newChatData)
        );
      }else{
        return false
      }
      
    },
    owner(){
      return this.chatData && this.chatData.created_by ? this.chatData.created_by : this.$auth.user.user_id;
    }
  },
  methods: {
    ...mapActions({
      sendMOMSignatureDocumentEmail: "agenda/sendMOMSignatureDocumentEmail",
      createMeetingChat: "agenda/createMeetingChat",
      updateMeetingChat: "agenda/updateMeetingChat",
    }),
    close,
    openSignerSelectDialog,
    confirmDelete,
    onBack,
    createChatBox,
  },
};

        
async function createChatBox() {
  try {
        let response = null;
        const participantData = []
        this.chatForm.participants.forEach(element => {
          participantData.push({
            id: element.id,
            email: element.email,
          })
        });
        this.chatForm.participants = participantData
        if (this.chatData?.id) {
          response = await this.updateMeetingChat(this.chatForm);
          response.is_updated = true;
        } else {
          this.chatForm.id = createUUID();
          response = await this.createMeetingChat(this.chatForm);
        }
        this.$emit("chatCreated", response);
      } catch (error) {
        console.error(error);
      }
}

async function confirmDelete(id) {
  try {
    if (
      await this.$refs.confirmDelete.open(
        this.$t("agenda.hDeleteMessage"),
        this.$t("agenda.lblDeleteMessage")
      )
    ) {
      this.chatForm.participants = this.chatForm.participants.filter(signer => signer.id !== id);
    }
  } catch (error) {
    this.Loaderloading = false;
  }
}

function openSignerSelectDialog() {
  this.showParticipantSelectDialog = true;
}

function onBack() {
  this.$emit("back");
  this.close();
}

function close() {
  this.$emit("input", false);
}
</script>

<style  scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>